import { useState, useEffect, useCallback, useRef } from "react";
import { api } from "../api/api";

const useAtendimento = () => {
  const [fila, setFila] = useState([]);
  const isFetchingRef = useRef(false);

  const carregarFila = useCallback(async () => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;

    try {
      const response = await api.get("/atendimento", {
        withCredentials: true,
      });
      setFila(response.data);
    } catch (error) {
      console.error("Erro ao carregar fila", error);
    } finally {
      isFetchingRef.current = false;
    }
  }, []);

  useEffect(() => {
    carregarFila();

    const interval = setInterval(carregarFila, 140000);
    return () => clearInterval(interval);
  }, [carregarFila]);

  const checkinCliente = async (cliente) => {
    await api.post(
      "/atendimento/checkin",
      { _id: cliente._id },
      { withCredentials: true }
    );
    await carregarFila();
  };

  // 🗓️ Agendar atendimento futuro (data e hora)
  const agendarAtendimento = async (dadosAgendamento) => {
    await api.post(
      "/atendimento/agendar",
      dadosAgendamento,
      { withCredentials: true }
    );
    await carregarFila();
  };

  const cancelarAtendimento = async (id) => {
    await api.put(
      `/atendimento/${id}/cancelar`,
      {},
      { withCredentials: true }
    );
    await carregarFila();
  };

  const iniciarAtendimento = async (id, recarregar = true) => {
    const response = await api.put(
      `/atendimento/${id}/iniciar`,
      {},
      { withCredentials: true }
    );

    if (recarregar) {
      await carregarFila();
    }

    return response.data;
  };

  // 📝 NOVA FUNÇÃO: Grava/Atualiza a ficha de atendimento (assunto, descricao, etc.) no banco de dados
  const salvarAtendimento = async (id, dados) => {
    const response = await api.put(
      `/atendimento/${id}`,
      dados,
      { withCredentials: true }
    );
    return response.data;
  };

  const finalizarAtendimento = async (id) => {
    await api.put(
      `/atendimento/${id}/finalizar`,
      {},
      { withCredentials: true }
    );
    await carregarFila();
  };

  // 🔥 Estabilizado com useCallback
  const buscarAtendimentoPorId = useCallback(async (id) => {
    if (!id) return null;
    const response = await api.get(`/atendimento/${id}`, {
      withCredentials: true,
    });
    return response.data;
  }, []);

  // 📌 NOVA FUNÇÃO: Busca atendimentos pelo ID do CLIENTE
  const buscarAtendimentosPorCliente = useCallback(async (clienteId) => {
    if (!clienteId) return [];
    const response = await api.get(`/atendimento/cliente/${clienteId}`, {
      withCredentials: true,
    });
    return response.data;
  }, []);

  return {
    fila,
    checkinCliente,
    agendarAtendimento,
    iniciarAtendimento,
    salvarAtendimento, // 👈 Exportado para uso na FichaAtendimento
    finalizarAtendimento,
    buscarAtendimentoPorId,
    buscarAtendimentosPorCliente,
    cancelarAtendimento,
  };
};

export default useAtendimento;